import React from "react";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useWorkingStates } from "contexts/WorkingStatesContext";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import * as XLSX from "xlsx";
import SuspenseComponent from "../../components/SuspenseComponent";

const InsightsTable = ({ valueDateRange, data, loading }) => {
    const workingStates = useWorkingStates();

    const processedData =
        data && Object.entries(data).length
            ? Object.entries(data).map(([machine, details]) => ({
                machine,
                working_state: workingStates?.find((elem) => details.working_state_id === elem.id)?.name,
                location_name: details.location_name,
                sales: details["buy/rent"],
                swap: details.swap_paid + details.swap,
                return: details.return,
                return_fail: details.fails,
                qr_scans: details.qr_scans,
                swap_fails: details.swap_fails,
                resets: details.resets,
                currency: details?.currency ?? "N/A",
                deposit_value: details?.deposit_value ?? "N/A",
                rental_fee: details?.rental_fee ?? "N/A",
            }))
            : [];

    const exportToExcel = () => {
        if (!processedData.length) return;

        const headers = [
            "Machine", "State", "Location", "Sales", "Swaps", "Returns", "Return Fail",
            "QRs scanned", "Swap Fail", "Resets", "Currency", "Deposit", "Rental fee",
        ];

        const worksheet = XLSX.utils.aoa_to_sheet([
            headers,
            ...processedData.map((item) => [
                item.machine,
                item.working_state,
                item.location_name,
                item.sales,
                item.swap,
                item.return,
                item.return_fail,
                item.qr_scans,
                item.swap_fails,
                item.resets,
                item.currency,
                item.deposit_value,
                item.rental_fee,
            ]),
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Insights");

        const formatDate = (date) => {
            const d = new Date(date);
            return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
        };

        const startDate = formatDate(valueDateRange[0]);
        const endDate = formatDate(valueDateRange[1]);
        XLSX.writeFile(workbook, `Insights_report_${startDate}_to_${endDate}.xlsx`);
    };

    const showLoader = loading;
    const showData = processedData.length && !loading;

    const getTrProps = () => ({ style: { background: "green", color: "white" } });

    return (
        <Row>
            <Col xs={12}>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4">Insights Data</CardTitle>
                    </CardHeader>
                    <CardBody>
                    {showLoader ? (
                        <SuspenseComponent />
                    ) : showData ? (
                        <div className="insights-table-wrapper">
                            <div className="insights-table">
                                <Button className="btn-fill mb-3" color="primary" onClick={exportToExcel}>
                                    Export to Excel
                                </Button>
                                <ReactTable
                                    data={processedData}
                                    filterable
                                    resizable={false}
                                    columns={[
                                        { Header: "Machine", accessor: "machine", sortable: true },
                                        { Header: "State", accessor: "working_state", sortable: true },
                                        { Header: "Location", accessor: "location_name", sortable: true },
                                        { Header: "Sales", accessor: "sales", sortable: true },
                                        { Header: "Swaps", accessor: "swap", sortable: true },
                                        { Header: "Returns", accessor: "return", sortable: true },
                                        { Header: "Return fail", accessor: "return_fail", sortable: true },
                                        { Header: "Swap fail", accessor: "swap_fails", sortable: true },
                                        { Header: "QRs scanned", accessor: "qr_scans", sortable: true },
                                        { Header: "Resets", accessor: "resets", sortable: true },
                                        { Header: "Currency", accessor: "currency", sortable: true },
                                        { Header: "Rental fee", accessor: "rental_fee", sortable: true },
                                        { Header: "Deposit", accessor: "deposit_value", sortable: true },
                                        { Header: "", accessor: "actions", sortable: false, filterable: false },
                                    ]}
                                    getTrProps={getTrProps}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                    ) : (
                        <p className="text-center">No data available for selected date range.</p>
                    )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default InsightsTable;
